module.exports = __webpack_public_path__ + "static/media/GRP Logo_vectorized2.7879719f.png";